(() => {
  const main = document.querySelector('main[data-template^="product"]');
  if (!main) return;

  main.classList.add('mf-universal-product-template');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  main.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute('href');
    if (!id || id === '#') return;
    const target = document.querySelector(id);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    if (target.getAttribute('aria-hidden') !== 'true') {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  });

  const reviewSection = main.querySelector('.mf-judgeme-reviews');
  if (reviewSection) {
    const observer = new MutationObserver(() => {
      const widget = reviewSection.querySelector('.jdgm-rev-widg');
      reviewSection.toggleAttribute('data-widget-ready', Boolean(widget));
    });
    observer.observe(reviewSection, { childList: true, subtree: true });
  }
})();
